var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("d2-container", {
    staticClass: "release"
  }, [_c("DetailTop", {
    attrs: {
      info: _vm.dataSource,
      showClose: !!_vm.showReply
    }
  }), _c("DetailUserInfo", {
    attrs: {
      info: _vm.userInfo
    },
    on: {
      update: _vm.getUserBaseInfo
    }
  }), _vm.showReply ? _c("div", {
    staticClass: "reply box"
  }, [_c("div", [_c("el-input", {
    ref: "answerInput",
    attrs: {
      type: "textarea",
      placeholder: "请输入回复内容。@+关键词可搜索常用回复。",
      maxlength: "500",
      "show-word-limit": "",
      autosize: {
        minRows: 4,
        maxRows: 6
      }
    },
    on: {
      input: _vm.handleInput,
      blur: _vm.closeFastReply,
      focus: _vm.closeFastReply
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1), _c("div", {
    staticClass: "reply-action wlc-space-between"
  }, [_c("div", [_c("SchematicImg", {
    attrs: {
      max: 5
    },
    model: {
      value: _vm.form.imgs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "imgs", $$v);
      },
      expression: "form.imgs"
    }
  })], 1), _c("el-button", {
    staticClass: "send-btn wlc-f-c",
    attrs: {
      type: "success",
      loading: _vm.sending
    },
    on: {
      click: _vm.addReply
    }
  }, [_vm._v("发送消息 ")])], 1)]) : _vm._e(), _c("MsgList", {
    attrs: {
      list: this.dataSource.list,
      total: _vm.total,
      status: _vm.dataSource.status,
      info: _vm.dataSource
    }
  }), _c("Close", {
    attrs: {
      info: _vm.dataSource,
      showClose: !!_vm.showReply
    }
  })], 1), _vm.showReply ? _c("CommonReply", {
    on: {
      select: _vm.selectAnswer
    }
  }) : _vm._e(), _vm.atPosition.show ? _c("FastReply", {
    ref: "fastReply",
    style: {
      position: "fixed",
      left: _vm.atPosition.left + "px",
      top: _vm.atPosition.top + _vm.atPosition.height + "px",
      zIndex: 1000,
      transform: "translateY(2px)"
    },
    attrs: {
      keyword: _vm.atPosition.keyword
    },
    on: {
      select: _vm.selectAnswer
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };